<template>
	<div class="input-autocomplete">
		<input
			type="text"
			:placeholder="placeholder"
			@input="on_change()"
			v-model="search"
			@focus="on_focus()"
			@blur="on_blur()"
			@keydown.down="on_arrow_down()"
			@keydown.up="on_arrow_up()"
			@keydown.enter="on_enter()"
			ref="input"
			:disabled="isDisabled"
		/>
		<div class="autocomplete">
			<div
				v-show="(focus && search && results.length) || (focus && showonfocus)"
				class="items"
			>
				<div
					class="item"
					v-for="(item, i) in results"
					:key="i"
					@mousedown="validate_item(i)"
					@mouseenter="select_item(i)"
					:class="{ selected: selected_index == i }"
				>
					{{ item.label }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "input-autocomplete",
	data () {
		return {
			search: "",
			selected_index: 0,
			focus: false,
		};
	},
	props: [ "value", "items", "placeholder","readonly", "showonfocus", "itemtext" ],
	computed: {
		results: function () {
			const that = this;

			if(this.showonfocus && this.search === "") {
				return this.items;
			}

			return this.items.filter(function (item) { return _.deburr(item.label.toLowerCase()).indexOf(_.deburr(that.search.toLowerCase())) > -1; });
		},
		isDisabled: function () {
			return this.readonly =="true" ? true : false;
			///return true
		}
	},
	watch: {
		search (value) {
			this.$emit("query", value);
		}
	},
	methods: {
		on_change: function () {
			this.selected_index = 0;
		},
		on_arrow_down: function () {
			this.selected_index++;
			if (this.selected_index > this.results.length-1) this.selected_index = 0;
		},
		on_arrow_up: function () {
			this.selected_index--;
			if (this.selected_index < 0) this.selected_index = this.results.length - 1;
		},
		on_enter: function () {
			this.validate_item(this.selected_index);
		},
		on_focus: function () {
			this.focus = true;
		},
		on_blur: function () {
			setTimeout(() => {
				this.focus = false;
			});
		},
		select_item: function (i) {
			this.selected_index = i;
		},
		validate_item: function (i) {
			const item = _.nth(this.results, i);
			if (this.search) {
				if (item) {
					this.selected_index = i;
					this.$emit("input", { item: item.value });
					this.search = "";
					this.$refs.input.focus();
				}
			} else {
				this.$emit("input", { item: item.value });
				this.search = this.itemtext ? item.value[this.itemtext] : item.value;
			}
		}
	},
};
</script>
<style lang="stylus" scoped>
@import '../../assets/css/app'

.input-autocomplete
	position relative
	width 100%
	input
		position absolute
		left 0
		top 0
		width 100%
		padding 0 16px
		font inherit
		color inherit
		border none
		background-color transparent
	.autocomplete
		position absolute
		left 0
		top 100%
		right 0
		z-index 100
		.items
			width 100%
			padding 8px 0
			margin 0
			max-height 120px
			border 1px solid #eee
			background-color #fff
			overflow auto
			.item
				display block
				padding 0 8px
				text-align left
				cursor pointer
				white-space nowrap
				line-height 24px
				&.selected
					background-color red
					color white
</style>
